import { render, staticRenderFns } from "./StudentScoreEdit.vue?vue&type=template&id=923f3074&scoped=true"
import script from "./StudentScoreEdit.vue?vue&type=script&lang=js"
export * from "./StudentScoreEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923f3074",
  null
  
)

export default component.exports